module.exports = __webpack_public_path__ + "img/gallery03.c3f43fce.jpg";